var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-card',{staticClass:"card-about"},[_c('h2',{staticClass:"text-center text-primary font-weight-bold position-relative main-header mb-5"},[_vm._v(" "+_vm._s(_vm.$t("auth.aboutUs"))+" ")]),_c('p',{staticClass:"text-center font-size-20 text-black"},[_vm._v(" "+_vm._s(_vm.aboutUs)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }